<template>

  <div>
    <b-modal
      v-model="modalOpen"
      footer-class="removed"
      centered
      no-close-on-backdrop
      v-bind="$attrs"
      v-on="$listeners"
      :title="mainTitle"
    >
      <slot name="body">
          
    <div class="">
      <validation-observer ref="disintegrationNgo">
        <b-form @submit.prevent="onSubmit">
          <b-row>
            <b-col cols="12">
            
            <form-select
              label="رقم قرار الهيئة العامة / مجلس الأمناء التي تم خلالها الموافقة على حل المنظمة"
              v-model="form.meeting_minute_id"
              :getOptionLabel="(x) => x.meeting_minutes_label"
              :reduce="(x) => x"
              id="gov"
              ep="v2/selects/meeting-minutes"
              ref="gov"
              rules="required"
            />
            
            <small class="text-secondary mb-1 d-block" style="margin-top: -10px;">
              في حال عدم وجود محضر الاجتماع يُرجى تقديم معاملة بالمحضر الجديد
            </small>
            
          </b-col>
            
            <b-col cols="12" class="mt-1">
              <form-input
                rules="required"
                label="اسم المصفي المعين من قبل المُنظمة"
                v-model="form.name"
                
              />

            </b-col>
            <b-col cols="12" class="mt-1">
              <form-autocomplete
              :getOptionLabel="(x) => x.name_ar"
              :reduce="(x) => x"
              v-model="form.alternative_ngo_id"
              ep="v2/guest/filter-name"
              id="ngos"
              filterKey="name"
              label="المنظمة الذي تمَّ اختيارها لتؤول أموال المُنظمة طالبة الحل لها"
              rules="required"
            />

            </b-col>
          </b-row>
          <hr />

          <b-row class="px-1 justify-content-end">
            <b-button @click="modalOpen = false" class="mx-1">إلغاء</b-button>
            <save-btn
              type="submit"
              variant="success"
              :loading="loading"
              :label="btnLabel"
            >
            </save-btn>
          </b-row>
        </b-form>
      </validation-observer>
    </div>
      </slot>
    </b-modal>
  </div>
</template>


<script>

import {
  BRow,
  BCol,
  BCard,
  BCardText,
  BCardTitle,
  BModal,
  BFormGroup,
  BFormFile,
  BFormRadio,
  BForm,
  BFormTextarea,
  BButton,
  BSidebar,
  BFormCheckbox
  
} from "bootstrap-vue";
import { ValidationObserver } from "vee-validate";
import formSelect from "@/components/form-select";
import formInput from "@/components/form-input";
import formTextarea from "@/components/form-textarea";
import saveBtn from "@/components/loader-btn";
import FormMask from "@/components/form-mask";
import { required, integer } from "@validations";
import mapSelect from "@/components/map-select";
import { ValidationProvider } from "vee-validate";
import FormImageInput from "@/components/FormImageInput.vue";
import { quillEditor } from "vue-quill-editor";
import FormFileInput from "@/components/FormFileInput.vue";
import FormCleave from "@/components/FormCleave";
import FormTextarea from "@/components/form-textarea/index.vue";
import { arrangement } from "@/utils/utils";
import { mapActions, mapGetters } from "vuex";
import formAutocomplete from "@/components/form-autocomplete";
const initForm = {};
export default {
  components: {
    formInput,
    formTextarea,
    formSelect,
    BButton,
    BSidebar,
    FormMask,
    saveBtn,
    BRow,
    BCol,
    mapSelect,
    BCard,
    BCardText,
    BCardTitle,
    BModal,
    BFormGroup,
    BFormFile,
    BForm,
    BFormRadio,
    BFormTextarea,
    ValidationObserver,
    ValidationProvider,
    FormImageInput , 
    quillEditor ,
    FormFileInput , 
    FormCleave ,
    FormTextarea , 
    BFormCheckbox , 
    formAutocomplete
  },
  props: {
    value: Boolean,
    title: String,
    mainTitle: {
      type: String,
      default: () => "بيانات معاملة",
    },
    btnLabel: String,
    loading: Boolean,
    intializeForm: {
      type: Object,
      default: () => initForm,
    },
  },
  computed: {
    ...mapGetters("Transactions/Transactions", ["TransactionType"]),
  },
  methods: {
    ...mapActions("Transactions/Transactions", ["fetchTransactionType"]),
  },
  data() {
    return {
      form: {},
      required,
      integer,
    };
  },
  computed: {
    modalOpen: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      },
    },
  },
  watch: {
    modalOpen(val) {
      if (val)
        this.$nextTick(() => {
          // this.init(this.intializeForm);
        });
    },
  },

  methods: {
    init(form) {
      this.form = JSON.parse(JSON.stringify(form));
    },
    async onSubmit() {
      await this.$refs.disintegrationNgo.validate().then(async (success) => {
        if (success) {
          this.$emit("confirm", this.form);
        }
      });
    },
    getArrangement(num){
      return arrangement(num)
    }
  },
};
</script>
